import React, {Component} from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Button, Header, Modal} from 'semantic-ui-react'

export default class ChooseLongTermDateModal extends Component {

    state = {
        startDate: new Date()
    };

    handleChange = date => this.setState({startDate: date});

    handleSubmit = () => this.props.setLongTermDate(this.state.startDate);

    render() {
        return (
            <Modal
                open={this.props.open}
                basic
                size='small'
                closeOnEscape={true}
                closeOnDimmerClick={true}
            >
                <Header icon='users' content='Hvor lenge blir du avmeldt?'/>
                <Modal.Content>
                    <DatePicker
                        selected={this.state.startDate}
                        onChange={this.handleChange}
                    />
                </Modal.Content>
                {
                    <Modal.Actions>
                        <Button inverted onClick={this.handleSubmit} color='green' content='OK'/>
                    </Modal.Actions>}
            </Modal>)
    }
}



// WEBPACK FOOTER //
// ./src/Components/ChooseLongTermDateModal.js